import { AppState } from '~/providers'
import type { IComputedExperiments } from '~/types/experiment'

export const useExperiment = () => {
  const { ssrContext } = useNuxtApp()

  return useState<IComputedExperiments>(AppState.Experiments, () => ssrContext?.event.context.experiments).value
}
